module.exports = __webpack_public_path__ + "static/media/user-guide.29b79b56.JPG";